import axios from 'axios'

const client = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
  headers: {
    'content-type' : 'application/x-www-form-urlencoded'
  },
})

client.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default client
